module.exports = __webpack_public_path__ + "images/emoji/clubs.caadca3f1418301afb93.png";